import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]根据类型获取基金列表信息
 */
export function fundListUsingPOST(
  req: FundTypeDto | void,
  config?: RequestConfig
): Promise<ApiResultFundInfoResultParam> {
  return resource.postNoAuth('/fundMarket/fundList', req, config);
}

/**
 * [No Auth]基金查询
 */
export function fundQueryUsingPOST(
  req: FundQueryDto | void,
  config?: RequestConfig
): Promise<ApiResultListFundQueryParam> {
  return resource.postNoAuth('/fundMarket/fundQuery', req, config);
}

/**
 * [No Auth]基金查询--智投
 */
export function fundQuery4ztUsingPOST(
  req: FundQueryDto | void,
  config?: RequestConfig
): Promise<ApiResultListFundQueryParam4zt> {
  return resource.postNoAuth('/fundMarket/fundQuery4zt', req, config);
}

/**
 * [No Auth]基金类型列表
 */
export function fundTypeListUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultListFundTypeParam> {
  return resource.postNoAuth('/fundMarket/fundTypeList', req, config);
}

/**
 * [No Auth]同步智投基金数据
 */
export function syncFundData4ztUsingPOST(
  req: SyncFundData4ztDto | void,
  config?: RequestConfig
): Promise<ApiResultstring> {
  return resource.postNoAuth('/fundMarket/syncFundData4zt', req, config);
}

/**
 * 智投产品推荐
 */
export function getZtRecommendUsingPOST(
  req: RecommendFund4ztDto | void,
  config?: RequestConfig
): Promise<ApiResultListRecommendFund4ztParam> {
  return resource.post('/fundMarket/ztRecommend', req, config);
}
